import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService  } from '../core/cache.service';
import { ApiService  } from '../core/api.service';
import { Mappings} from '../../shared/mapping';
import { SliderViewModel } from "./../../models/cms/cms-page";

@Injectable()
export class SliderService 
{
    constructor
    (
        public _api: ApiService, 
        public _cache: CacheService,
        private mappings: Mappings
    ) {}

}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/slider.service.ts